import { EnrichedClusterConfig, GetGameStartDataResponse } from './server';
import { Account } from "./account";

export type GameStartData = {
    browser: string,
    client_id: string,
    cluster_config: EnrichedClusterConfig
    cluster_name: string,
    country: string,
    deny_tutorial: 1,
    entry_point: string,
    first_name: string,
    flag_spoof: 1,
    isLinked: boolean,
    hasBookmark: boolean,
    last_name: string,
    locale: string,
    os: string,
    photo: string,
    preloader: string,
    preloader_bg: string,
    preloader_img: string,
    restApiUrl: string,
    reg_preloader_bg: string,
    reg_preloader_img: string,
    sig: string,
    sig_funnel: string,
    suid: string,
    suid_simulate: string,
    time_from_load_page: number,
    mobile_static_url: string,
    game_static_noduplicates: string,
    game_static_vectors: string,
    game_static_strings: string,
    user: { result: GetGameStartDataResponse },
    user_agent: string,
    user_currency: string,
    wait_for_web_auth: number,
    account_token: string
    device_id: string
    accountId: number,
    account: Account
};

export type GameStartShortData = {
    restApiUrl: string,
    browser: string,
    clusterConfig: EnrichedClusterConfig,
    entryPoint: string,
    locale: string,
    deviceId: string,
    accountId: number,
    accountToken: string,
    sig: string,
    suid: string,
    suidSimulate: string
}


export const UnityObjectNames = {
    UnityBrowserApi: 'UnityBrowserApi'
} as const;

export type UnityObjectNames = typeof UnityObjectNames[keyof typeof UnityObjectNames];

export const UnityBrowserApiMethods = {
    Receive: 'Receive',
    OpenAccountWindow: 'OpenAccountWindow'
} as const;

export type UnityBrowserApiMethods = typeof UnityBrowserApiMethods[keyof typeof UnityBrowserApiMethods];

export type Webgl2020GameInstance = {
    Module: {
        canvas: HTMLCanvasElement
    },
    /**
     * https://docs.unity3d.com/2021.3/Documentation/Manual/web-interacting-browser-unity-to-js.html
     * return seems to be void actually
     */
    SendMessage: <T>(objectName: UnityObjectNames, methodName: UnityBrowserApiMethods, options?: string|number) => T,
    SetFullScreen: Function,
    Quit: Function
}

